import {
  Card,
  CardBody,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
  Table,
  CardHeader,
  CardTitle,
  FormGroup,
  Input,
  Button,
  Form,
} from "reactstrap";
import { useState, React, useEffect, useContext } from "react";
import { NavLink, useHistory } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "moment-timezone";
import { MainContext } from "context/MainContext.js";
import LoadingOverlay from "react-loading-overlay";
import ReactBSAlert from "react-bootstrap-sweetalert";
LoadingOverlay.propTypes = undefined;

import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Utilities from "components/Utils/utilities";
import { FaExclamationTriangle } from "react-icons/fa";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { BsFillXCircleFill } from "react-icons/bs";

const LicensesList = () => {
  const history = useHistory();
  const privileges = useContext(MainContext);

  let formError = false;
  const [uniqueIdentifier, setUniqueIdentifier] = useState("");
  const [registrationCode, setRegistrationCode] = useState("");
  const [gamLimit, setGamLimit] = useState("");
  const [licenseEndDate, setLicenseEndDate] = useState("");
  const [types, setTypes] = useState("");
  const [alert, setAlert] = useState(null);

  const [errorMsg, setErrorMsg] = useState([]);
  const [showLoading, setShowLoading] = useState(false);

  useEffect(() => {
    if (!Utilities.hasAccess(privileges["versions.licenses.display"])) {
      history.push({ pathname: "/" });
    } else if (Utilities.hasAgreedTerms() == "false") {
      history.push({ pathname: "/auth/terms" });
    }

    fetchData();
  }, []);

  const showExpirationWarning = () => {
    if (licenseEndDate) {
      const currentDate = new Date();
      const targetDateObj = new Date(licenseEndDate);
      const timeDifference = targetDateObj - currentDate;
      const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));

      if (daysDifference <= 0) {
        return (
          <>
            <a id={"warningElement"} className="vmElement">
              <BsFillXCircleFill className="text-danger tableIconFontSize" />
            </a>
            <ReactTooltip
              anchorSelect={`#warningElement`}
              place="top"
              style={{ textAlign: "left", zIndex: "100" }}
            >
              <div>{"License expired, please contact sales department"}</div>
            </ReactTooltip>
          </>
        );
      } else if (daysDifference < 30) {
        return (
          <>
            <a id={"warningElement"} className="vmElement">
              <FaExclamationTriangle className="text-warning tableIconFontSize" />
            </a>
            <ReactTooltip
              anchorSelect={`#warningElement`}
              place="top"
              style={{ textAlign: "left", zIndex: "100" }}
            >
              <div>
                {"License expires soon, please contact the sales department"}
              </div>
            </ReactTooltip>
          </>
        );
      } else {
        return "";
      }
    }
  };

  const fetchData = () => {
    fetch("/api/v1/version/licenses", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
    })
      .then((response) => response.json())
      .then((actualData) => {
        if (actualData.status == "200") {
          setUniqueIdentifier(actualData.data.uniqueIdentifier);
          setRegistrationCode(actualData.data.registrationCode);
          setGamLimit(actualData.data.gamLimit);
          setLicenseEndDate(actualData.data.dateLimit);
          setTypes(actualData.data.types);
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    formError = false;
    if (!formError) {
      postData();
    }
  };

  const resetCodeChangeConfirm = () => {
    setAlert(
      <ReactBSAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title="Are you sure you want to reset your registration code?"
        onConfirm={() => resetCodeChange()}
        onCancel={() => hideAlert()}
        confirmBtnBsStyle="danger"
        cancelBtnBsStyle="info"
        confirmBtnText="Yes"
        cancelBtnText="Cancel"
        showCancel
        btnSize=""
      />,
    );
  };

  const resetCodeChange = () => {
    setShowLoading(true);
    fetch("/api/v1/version/licenses/resetRegistrationCode", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);
        if (actualData.status == "200") {
          setErrorMsg([]);
          setTypes("");
          sessionStorage.setItem("licenseTypes", "");
          setRegistrationCode("");
          toast.success("Registration code successfully reset", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
        } else {
          toast.error(
            "A problem occured while resetting the registration code",
            {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: false,
              theme: "colored",
            },
          );
        }
      })
      .catch((err) => {
        console.log(err.message);
        setShowLoading(false);
      });

    hideAlert();
  };

  const postData = () => {
    setShowLoading(true);

    fetch("/api/v1/version/licenses/register", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
      body: JSON.stringify({ registrationCode }),
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);
        if (actualData.status == "200") {
          if (actualData.data.registrationStatus) {
            setErrorMsg([]);
            sessionStorage.setItem("licenseTypes", actualData.data.types);
            fetchData();
            toast.success("Virtuoso Registered Successfully", {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: false,
              theme: "colored",
            });
          } else {
            setErrorMsg(["Invalid Key"]);
            toast.error("Invalid Key", {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: false,
              theme: "colored",
            });
          }
        } else {
          toast.error("A problem occured while registring Virtuoso", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
        }
      })
      .catch((err) => {
        console.log(err.message);
        setShowLoading(false);
      });
  };

  const handleRegistrationCodeChange = (e) => {
    setRegistrationCode(e.target.value);
  };

  const hideAlert = () => {
    setAlert(null);
  };

  return (
    <>
      <ToastContainer />
      <div className="content">
        <LoadingOverlay
          active={showLoading}
          spinner
          text="Loading"
          className={showLoading ? "loading" : ""}
        />
        {alert}
        <Row>
          <Col md="12">
            <Card>
              <CardBody>
                <Breadcrumb>
                  <BreadcrumbItem>
                    <NavLink to={{ pathname: "/admin/dashboard" }}>
                      <FontAwesomeIcon icon={faHome} />
                    </NavLink>
                  </BreadcrumbItem>
                  <BreadcrumbItem>Licenses</BreadcrumbItem>
                </Breadcrumb>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            {errorMsg.length > 0 && (
              <div
                style={{
                  backgroundColor: "#FFC0A4",
                  border: "1px solid #ef8157",
                  color: "#66615b",
                  paddingTop: "15px",
                  marginBottom: "15px",
                }}
              >
                <ul>
                  {errorMsg.map((d, index) => (
                    <li key={index}>{d}</li>
                  ))}
                </ul>
              </div>
            )}
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col sm="8">
                  <Card>
                    <CardHeader>
                      <CardTitle tag="h4">Virtuoso Registration</CardTitle>
                    </CardHeader>
                    <CardBody>
                      <Row style={{ marginBottom: "20px" }}>
                        <Col>
                          To activate the full version of Virtuoso, please send
                          this unique identifier and enter the registration code
                          in the field below
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <label>Unique Identifier</label>
                          <FormGroup>
                            <Input
                              type="text"
                              value={uniqueIdentifier || ""}
                              readOnly={true}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <label>Registration Code</label>
                          <FormGroup>
                            <Input
                              type="text"
                              onChange={handleRegistrationCodeChange}
                              value={registrationCode || ""}
                              readOnly={!!types}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          {types ? (
                            <Button
                              className="btn-round"
                              color="danger"
                              onClick={resetCodeChangeConfirm}
                            >
                              Reset Code
                            </Button>
                          ) : (
                            <Button
                              className="btn-round"
                              color="info"
                              type="submit"
                            >
                              Register
                            </Button>
                          )}
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
                {types ? (
                  <Col>
                    <Card>
                      <CardHeader>
                        <CardTitle tag="h4">Active License</CardTitle>
                      </CardHeader>
                      <CardBody>
                        <Row>
                          <Col>
                            <label>Gam Limit</label>
                            <FormGroup>{gamLimit}</FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <label>Expiration Date</label>
                            <FormGroup>
                              {licenseEndDate} {showExpirationWarning()}
                            </FormGroup>
                          </Col>
                          <Col></Col>
                        </Row>
                        <Row>
                          <Col>
                            <label>Types</label>
                            <FormGroup>
                              {types
                                .split(",")
                                .map(
                                  (word) =>
                                    word.charAt(0).toUpperCase() +
                                    word.slice(1),
                                )
                                .join(", ")}
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <label>Contact</label>
                            <FormGroup>
                              <a href="mailto:support@positronaccess.com">
                                Sales Support
                              </a>
                            </FormGroup>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>
                ) : (
                  <Col></Col>
                )}
              </Row>
            </Form>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default LicensesList;
